import { TableV2 } from '@medeloop/medeloop-components-library';
import { useMemo, useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { useGetUserOverview } from 'src/api/users-queries';
import { Study } from 'src/types/studies';

export const StudiesList = () => {
  const [searchTerm, setSearchTerm] = useState<string>('');
  const navigate = useNavigate();

  const { isLoading, data } = useGetUserOverview();

  const onRowClick = (row: Study) => {
    navigate(`/account/studies/${row.studyId}/participants`);
  };

  const headers = [
    { label: 'Name', key: 'name' },
    { label: 'Display name', key: 'displayName' },
    { label: 'Participants', key: 'participants' },
    { label: 'Start date', key: 'startDate' },
  ];

  const transformedData = useMemo(
    () =>
      data?.studies
        .filter(
          (study) =>
            study.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
            study.displayName.toLowerCase().includes(searchTerm.toLowerCase()),
        )
        .map((study) => ({
          id: study.studyId,
          name: study.name,
          displayName: study.displayName,
          participants: study.numParticipants ?? 0,
          startDate: new Date(study.createdAt).toLocaleDateString(),
          onClick: () => onRowClick(study),
        })) ?? [],
    [data, searchTerm],
  );

  return (
    <div className="flex flex-col gap-6 p-4 bg-background-dark-subdued rounded-lg">
      <TableV2
        headers={headers}
        data={transformedData}
        isLoading={isLoading}
        searchPlaceholder="Search studies"
        onSearch={(t) => setSearchTerm(t)}
      />
      <Outlet />
    </div>
  );
};
